import { createApp } from 'vue';
import LottieToGifConverter from '@/Components/LottieToGifConverter.vue';
import '@styles/app.css';

createApp(LottieToGifConverter).mount('#lottie-to-gif-converter');
